export const filterFromTable = (e, nameRow, list) => {
    const fullName = (el) => {
        return `${el?.lastName ? `${el?.lastName} ` : ''}${el?.firstName ? `${el?.firstName} ` : ''}${el?.middleName ? `${el?.middleName}` : ''}`.trim();
    };

    const getValueByPath = (obj, path) => {
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
    };

    // A column may search over several paths at once (e.g. payer display name + sync name)
    const getHaystackByPath = (obj, path) => {
        if (Array.isArray(path)) {
            return path.map((p) => getValueByPath(obj, p)).filter(Boolean).join(' ');
        }
        return getValueByPath(obj, path);
    };

    const inputValue = e.target.value.toString().toLowerCase();
    const terms = inputValue.split(/\s|,/).filter(Boolean);

    return nameRow
        ? nameRow === "firstName"
            ? list?.filter((el) => {
                const haystack = fullName(el[e.target.name]).toLowerCase();
                if (!haystack) return false;
                return terms.every((t) => haystack.includes(t));
            })
            : list?.filter((el) => {
                const haystack = (getHaystackByPath(el[e.target.name], nameRow) ?? '').toString().toLowerCase();
                return terms.every((t) => haystack.includes(t));
            })
        : e?.target.name === "statuses"
            ? list?.filter((el) => {
                const status = el?.status?.toString().toLowerCase();
                return terms.every((t) => status?.includes(t));
            })
            : list?.filter((el) => {
                const haystack = (getValueByPath(el, e.target.name) ?? '').toString().toLowerCase();
                return terms.every((t) => haystack.includes(t));
            });
};

export const multiFilterFromTable = (searched, list, headConfig) => {
    if (!list?.length) return [];

    const rowNameMap = new Map(
        headConfig?.filter(h => h?.name).map(h => [h.name, h.rowName]) || []
    );

    return Object.entries(searched).reduce((filtered, [name, value]) => {
        if (!value) return filtered;
        return filterFromTable(
            {target: {name, value}},
            rowNameMap.get(name),
            filtered
        );
    }, [...list]);
};
